import { Hero } from "../sections/Hero";
import { Marquee } from "../components/motion";
import { TrustStrip, ServicesSection, WhySection, AboutTeaser, ProcessSection } from "../sections/HomeBlocks";
import { PortfolioPreview, ReviewsSection, ServiceArea, FAQSection, FinalCTA, ContactBlock } from "../sections/HomeBlocks2";

export default function Home() {
  return (
    <main>
      <Hero />
      <Marquee items={["BHF Creative", "Website Design", "Video Ads", "Remote Worldwide", "Direct on WhatsApp"]} />
      <TrustStrip />
      <ServicesSection chapter="01" />
      <WhySection chapter="02" />
      <AboutTeaser chapter="03" />
      <ProcessSection chapter="04" />
      <PortfolioPreview chapter="05" />
      <ReviewsSection chapter="06" />
      <ServiceArea chapter="07" />
      <FAQSection chapter="08" limit={4} />
      <FinalCTA />
      <ContactBlock chapter="09" />
    </main>
  );
}
